import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoEntry = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M27.0713 12.9289L12.9292 27.0711",
		stroke: "#281E38",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.9289 27.0711C16.8342 30.9763 23.1658 30.9763 27.0711 27.0711C30.9763 23.1658 30.9763 16.8342 27.0711 12.9289C23.1658 9.02369 16.8342 9.02369 12.9289 12.9289C9.02369 16.8342 9.02369 23.1658 12.9289 27.0711Z",
		stroke: "#281E38",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgNoEntry);
export default ForwardRef;
